import { TOKEN_TYPE_TO_DETAILS, USER_STATUS_TO_LABEL } from '../../consts';
import { BaseFilterDetails, LastSeenFilterValue, MatchingStatusFilterValue, UsersFilters } from '../../types/filters';
import { UserStatus } from '../../types/userStatus';

export const STATUS_FILTER_DETAILS: BaseFilterDetails<UsersFilters> = {
    id: 'status',
    label: 'Status',
    multiple: true,
    searchable: false,
    options: [
        {
            value: UserStatus.Paired,
            label: USER_STATUS_TO_LABEL[UserStatus.Paired]
        },
        {
            value: UserStatus.Pending,
            label: USER_STATUS_TO_LABEL[UserStatus.Pending]
        },
        {
            value: UserStatus.Unpaired,
            label: USER_STATUS_TO_LABEL[UserStatus.Unpaired]
        },
        {
            value: UserStatus.Excluded,
            label: USER_STATUS_TO_LABEL[UserStatus.Excluded]
        },
        {
            value: UserStatus.Disabled,
            label: USER_STATUS_TO_LABEL[UserStatus.Disabled]
        },
        {
            value: UserStatus.Unprotected,
            label: USER_STATUS_TO_LABEL[UserStatus.Unprotected]
        }
    ]
};

export const TOKEN_FILTER_DETAILS: BaseFilterDetails<UsersFilters> = {
    id: 'token',
    label: 'Token type',
    multiple: true,
    searchable: false,
    options: Object.entries(TOKEN_TYPE_TO_DETAILS).map(([id, details]) => ({
        value: Number(id),
        label: details.label
    }))
};

export const LAST_SEEN_FILTER_DETAILS: BaseFilterDetails<UsersFilters> = {
    id: 'lastSeen',
    label: 'Last seen',
    multiple: false,
    searchable: false,
    options: [
        {
            value: LastSeenFilterValue.Last24Hours,
            label: 'Last 24 hours'
        },
        {
            value: LastSeenFilterValue.LastWeek,
            label: 'Last week'
        },
        {
            value: LastSeenFilterValue.LastMonth,
            label: 'Last month'
        },
        {
            value: LastSeenFilterValue.LastThreeMonths,
            label: 'Last 3 months'
        },
        {
            value: LastSeenFilterValue.LastSixMonths,
            label: 'Last 6 months'
        },
        {
            value: LastSeenFilterValue.LastYear,
            label: 'Last year'
        }
    ]
};

export const MATCHING_STATUS_FILTER_DETAILS: BaseFilterDetails<UsersFilters> = {
    id: 'matchingStatus',
    label: 'Matching status',
    multiple: true,
    searchable: false,
    options: [
        {
            value: MatchingStatusFilterValue.Matched,
            label: 'Matched'
        },
        {
            value: MatchingStatusFilterValue.Unmatched,
            label: 'Unmatched'
        }
    ]
};
